// Property type factories used to build appearance editors
import { StrokeType, FillType } from "../PropertyTypes";

// Canais (Channels) category - includes channel drawing tools
const canaisRegistry = {
  displayName: "Canais",
  interactives: {
    equidistantChannel: {
      displayName: "Canal Equidistante",
      key: "equidistantChannel",
      icon: "Channel",
      propName: "channels",
      component: "EquidistantChannel",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#9C27B0",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#9C27B0", opacity: 0.1 },
        }),
      ],
    },
    stdDevChannel: {
      displayName: "Canal Desvio Padrão",
      key: "stdDevChannel",
      icon: "Channel_StdDev",
      propName: "channels",
      component: "StandardDeviationChannel",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#4CAF50",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#4CAF50", opacity: 0.1 },
        }),
      ],
    },
    regressionLine: {
      displayName: "Linha de Regressão",
      key: "regressionLine",
      icon: "Channel",
      propName: "regressions",
      component: "RegressionLine",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
      ],
    },
    andrewsPitchfork: {
      displayName: "Garfo de Andrews",
      key: "andrewsPitchfork",
      icon: "Pitchfork",
      propName: "pitchforks",
      component: "AndrewsPitchfork",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FF6B6B",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
      ],
      // Internal properties for rendering (not exposed in UI)
      appearance: {
        r: 6, // drag handle radius
      },
    },
    quadrantLines: {
      displayName: "Linhas de Quadrante",
      key: "quadrantLines",
      icon: "Quadrant_Lines",
      propName: "quadrantLines",
      component: "QuadrantLines",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
    tironeLevels: {
      displayName: "Níveis de Tirone",
      key: "tironeLevels",
      icon: "Tirone_Levels",
      propName: "tironeLevels",
      component: "TironeLevels",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 1,
            opacity: 1,
          },
        }),
      ],
    },
  },
};

export default canaisRegistry;
